import Vue from 'vue';
import {ServerTable, ClientTable} from 'vue-tables-2';



Vue.use(ServerTable);
Vue.use(ClientTable);